export enum AccountType {
  Borrower = 'BORROWER',
  NonBorrowingTitleHolder = 'NBTH',
  Seller = 'SELLER',
  SigningAgent ='SIGNINGAGENT',
  SettlementAgent = 'SETTLEMENTAGENT',
  Witness = 'WITNESS'
}
